module.exports = __webpack_public_path__ + "media/images/icons/settings-97c9da3048e984d43351807ce04cf464.svg";